import React, { memo } from 'react';
import { withRouter } from 'react-router-dom';
import ListSearchHeader from '../../../shared/components/ListSearchHeader/ListSeachHeader';
import LoaderButton from '../../../shared/components/LoaderButton/LoaderButton';
import styles from './userListSearchHeader.module.scss';

export default memo(withRouter(function UserListSearchHeader(props) {
    function handleOnChange(event) {
        props.cleanUsers();
        props.getUsersRequest(1, 0, event.target.value);
    }

    function handleClick() {
        props.history.push('/users/new');
    }

    return (
        <div className={styles.searchHeaderContainer}>
            <ListSearchHeader dictionary="users" text="search_user" onChange={handleOnChange} />
            {
                props.permissions!==null && parseInt(props.permissions[0])==11 ?
                <LoaderButton dictionary="users" onClick={handleClick} text="add_user" /> :
                null
            }
        </div>
    );
}));
